import React, { useState } from "react";
import * as styles from "./about-css-modules.module.css";
import Slider from "../components/light-dark";
export default function About() {
  const [light, setLight] = useState(true);
  return (
    <div className={styles.outer}>
      <div className={`${styles.inner} ${!light ? styles.dark : styles.light}`}>
        {/* <button onClick={() => setLight(prevState => !prevState)}>
          Change
        </button> */}
        <Slider clickHandler={() => setLight(prevState => !prevState)} />
        <img
          src={light ? "/birthday1.gif" : "/birthday3.gif"}
          className={styles.gif}
        />
      </div>
    </div>
  );
}
